<template>
  <FontAwesomeIcon
    :icon="[type, icon]"
    :border="border"
    :fixedWidth="fixedWidth"
    :flip="flip"
    :mask="mask"
    :listItem="listItem"
    :pull="pull"
    :pulse="pulse"
    :rotation="rotation"
    :size="size"
    :spin="spin"
    :transform="transform"
    :symbol="symbol"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';

import '@fortawesome/fontawesome-pro/js/all';

@Component({
  components: {
    FontAwesomeIcon
  }
})
class FA extends Vue {
  @Prop({ type: String, default: 'fas' }) type;
  @Prop({ type: String, default: 'info' }) icon;
  @Prop({ default: () => null }) border;
  @Prop({ default: () => null }) fixedWidth;
  @Prop({ default: () => null }) flip;
  @Prop({ default: () => null }) mask;
  @Prop({ default: () => null }) listItem;
  @Prop({ default: () => null }) pull;
  @Prop({ default: () => null }) pulse;
  @Prop({ default: () => null }) rotation;
  @Prop({ default: () => null }) size;
  @Prop({ default: () => null }) spin;
  @Prop({ default: () => null }) transform;
  @Prop({ default: () => null }) symbol;
}

export default FA;
</script>



// WEBPACK FOOTER //
// src/components/FA.vue